import React from 'react';
import { Star, Instagram, Facebook, Youtube, Music } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-tx-primary border-t border-tx-border pt-16 pb-8" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-16" data-id="element-92">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-93">
            <a href="#hero" className="flex items-center gap-2 mb-4" data-id="element-94">
              <Star className="w-8 h-8 text-tx-red fill-current" data-id="element-95" />
              <span className="font-heading text-5xl tracking-widest text-tx-cream" data-id="element-96">
                TEXARKANA
              </span>
            </a>
            <p className="text-tx-cream/60 font-body text-center md:text-left max-w-xs" data-id="element-97">
              Southern Rock & Country Cover Band. Bringing the spirit of legends
              to every stage.
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-98">
            <h4 className="font-heading text-2xl text-tx-gold tracking-widest mb-4" data-id="element-99">
              CONTACT
            </h4>
            <a href="mailto:booking@texarkana.com" className="text-tx-cream/80 hover:text-tx-red transition-colors font-body mb-2" data-id="element-100">
              booking@texarkana.band
            </a>
            <a href="tel:+528115077138" className="text-tx-cream/80 hover:text-tx-red transition-colors font-body" data-id="element-101">
              (81) 1507-7138
            </a>
          </div>

          {/* Socials */}
          <div className="flex flex-col items-center md:items-start" data-id="element-102">
            <h4 className="font-heading text-2xl text-tx-gold tracking-widest mb-4" data-id="element-103">
              FOLLOW US
            </h4>
            <div className="flex gap-4" data-id="element-104">
              <a href="http://instagram.com/texarkanaband" target="" className="w-12 h-12 rounded-full border border-tx-border flex items-center justify-center text-tx-cream hover:bg-tx-red hover:border-tx-red transition-all duration-300" aria-label="Instagram" data-id="element-105">
                <Instagram className="w-5 h-5" data-id="element-106" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-tx-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-107">
          <p className="text-tx-cream/40 font-body text-sm" data-id="element-108">
            &copy; {currentYear} Texarkana Band. All rights reserved.
          </p>
          <div className="flex gap-6 text-tx-cream/40 font-body text-sm" data-id="element-109">
            <a href="#" className="hover:text-tx-cream transition-colors" data-id="element-110">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-tx-cream transition-colors" data-id="element-111">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}